/* istanbul ignore file */

import { forBrands, Theme, CSSObject } from '@core-ui/react-stitch';

const getPaddingRightForBRandBRFS = () => ({
  paddingRight: '1.375rem'
});

const getBackgroundPositionForAthleta = () => ({
  backgroundPositionY: '18px'
});

const getBackgroundPositionForGap = (): CSSObject => ({
  backgroundPositionY: '16px'
});

const getColorBrandForGap = (theme: Theme): CSSObject => ({
  color: theme.color.b1
});

const getSizeModelTogglePrefixForBananaRepublic = () => ({
  fontSize: '1rem',
  fontWeight: '400'
});

export const sizeModelToggleContainerStyle = (theme: Theme): CSSObject => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  // @ts-ignore
  '& .size-model-toggle__control': {
    border: 'none',
    paddingRight: '1.375em',
    animation: 'none',
    backgroundImage: 'none',
    fontWeight: '400',
    // @ts-ignore
    ...forBrands(theme, {
      br: getPaddingRightForBRandBRFS,
      brfs: getPaddingRightForBRandBRFS
    }),

    '&::before': {
      '@media (min-width: 1024px)': {
        top: '-1px'
      },
      backgroundColor: 'transparent',
      // @ts-ignore
      ...forBrands(theme, {
        at: getBackgroundPositionForAthleta,
        gap: getBackgroundPositionForGap,
        gapfs: getBackgroundPositionForGap
      })
    }
  }
});

export const sizeModelToggleControlPrefixStyle = (theme: Theme): CSSObject => ({
  height: 'auto',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontSize: '1.0625rem',
  marginRight: '3px',
  fontWeight: 'bold',
  color: theme.color.b1,

  ...theme.brandFont,
  // @ts-ignore
  ...forBrands(theme, {
    gap: getColorBrandForGap,
    gapfs: getColorBrandForGap,
    // @ts-ignore
    br: getSizeModelTogglePrefixForBananaRepublic
  })
});

const getMinWidth = (): CSSObject => ({
  minWidth: '7rem'
});

export const sizeModelToggleMobileStyle = (theme: Theme): CSSObject => ({
  marginTop: '0',

  '& .size-model-toggle': {
    '&__control': {
      border: 'none',
      animation: 'none',
      backgroundImage: 'none',
      fontWeight: 'normal',
      '@media (min-width: 1024px)': {
        fontWeight: 'bold'
      },
      color: theme.color.b1,
      // @ts-ignore
      ...forBrands(theme, {
        br: getPaddingRightForBRandBRFS,
        brfs: getPaddingRightForBRandBRFS
      }),
      '&:before': {
        backgroundColor: 'transparent',
        // @ts-ignore
        ...forBrands(theme, {
          at: getBackgroundPositionForAthleta,
          gap: getBackgroundPositionForGap,
          gapfs: getBackgroundPositionForGap
        })
      }
    },

    '&__control, &__option, &-native__select, & select': {
      color: theme.color.b1,
      height: 'auto',
      textAlign: 'center',
      textTransform: 'uppercase',
      border: 'none',
      // @ts-ignore
      ...forBrands(theme, {
        gap: getColorBrandForGap,
        gapfs: getColorBrandForGap
      })
    },

    '&__option, &-native__option': {
      border: `1px ${theme.color.gray20} solid`,
      borderBottom: 'none',
      position: 'relative',
      minWidth: '6rem',
      '@media (min-width: 1024px)': {
        fontWeight: 'bold'
      },
      // @ts-ignore
      ...forBrands(theme, {
        gap: getMinWidth,
        gapfs: getMinWidth,
        at: getMinWidth,
        // @ts-ignore
        hc: getMinWidth
      }),

      '&:last-of-type': {
        borderBottom: `1px ${theme.color.gray20} solid`
      },

      '&[aria-selected=true]': {
        backgroundColor: 'inherit'
      },

      '&[aria-selected="true"]:before': {
        content: '" "',
        position: 'absolute',
        borderBottom: `3px solid ${theme.color.b1}`,
        borderRight: `3px solid ${theme.color.b1}`,
        paddingTop: '1px',
        left: '1.25rem',
        transform: 'rotate(45deg)',
        height: '10px',
        width: '4px',
        // @ts-ignore
        ...forBrands(theme, {
          gap: () => ({ left: '1rem' }),
          gapfs: () => ({ left: '1rem' }),
          at: () => ({ top: '0,625rem' }),
          // @ts-ignore
          hc: () => ({ left: '1rem' }),
          br: () => ({ left: '1.5rem' }),
          brfs: () => ({ left: '1.5rem' })
        })
      },

      '&--highlighted': {
        '&[aria-selected="true"]': {
          backgroundColor: theme.color.gray05
        }
      }
    },

    '&__menu': {
      right: '0',
      marginTop: '0.125rem',
      minWidth: '12rem',
      left: '50%',
      transform: 'translateX(-50%)'
    },

    '& select': {
      borderBottom: 'none',
      top: '0.2em',
      paddingRight: '1.25rem'
    }
  }
});
